module.exports = __webpack_public_path__ + "img/img_6.a034e32d.png";